import classNames from 'classnames';
import React, { useCallback } from 'react';
import { TextFieldTheme, TextField as TPATextField } from 'wix-ui-tpa/cssVars';
import { FIELD_TYPES } from '../../constants';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import { useTranslation } from '../../contexts/translation-context';
import { useError } from '../../field-error';
import { useFieldAttributes } from '../../services/field-attributes';
import { FieldDescriptionWUT } from '../../ui/field-description/field-description-wut';
import { FieldLabelWUT } from '../../ui/field-label/field-label-wut';
import { FieldErrorWUT } from '../../ui/field-error/field-error-wut';
import { classes } from './vat-id.st.css';
import { getVatIDValue } from './vat-id-validation';
import { useExternalData } from '../../ui/form/contexts/external-data-context';
import { VatIDType } from './brazil-vat-id-validator';
const DEFAULT_VAT_ID_VALUE = {
  id: '',
  type: VatIDType.UNSPECIFIED
};
export const VatId = _ref => {
  let {
    id,
    hideLabel = false,
    placeholder,
    required = false,
    description,
    value = DEFAULT_VAT_ID_VALUE,
    onChange,
    onBlur,
    onFocus,
    error,
    disabled = false,
    customErrors,
    hidden,
    target,
    FieldLayout,
    requiredIndicatorType,
    requiredIndicatorPlacement
  } = _ref;
  const extenalData = useExternalData();
  const country = extenalData == null ? void 0 : extenalData.country;
  const {
    t
  } = useTranslation();
  const label = country === 'IL' ? t('field.vat-id.label-il') : t('field.vat-id.label-br');
  const fieldType = FIELD_TYPES.VAT_ID;
  const {
    hasError,
    errorMessage
  } = useError(error, customErrors, fieldType, country == null || country.toLowerCase == null ? void 0 : country.toLowerCase());
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  const handleChange = useCallback(event => {
    const newVatId = event.target.value;
    onChange(getVatIDValue(newVatId, country));
  }, [onChange, country]);
  const handleBlur = useCallback(event => {
    const newVatId = event.target.value;
    onChange(getVatIDValue(newVatId, country));
    onBlur == null || onBlur();
  }, [onChange, onBlur, country]);
  if (hidden) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      htmlFor: inputId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }),
    renderInput: () => /*#__PURE__*/React.createElement(TPATextField, {
      id: inputId,
      type: "text",
      error: hasError,
      newErrorMessage: true,
      value: value ? String(value.id) : '',
      className: classNames(classes.textField, classes.theme, {
        [classes.error]: hasError,
        [classes.hover]: forcedHover
      }),
      onChange: handleChange,
      required: required,
      disabled: disabled,
      placeholder: placeholder,
      onBlur: handleBlur,
      onFocus: onFocus,
      "aria-label": label,
      theme: TextFieldTheme.Box,
      "aria-describedby": ariaDescribedBy,
      "aria-invalid": hasError
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
};
export default VatId;
//# sourceMappingURL=vat-id.js.map